import React, { useState } from 'react';
import { SmilePlus } from 'lucide-react';
import { QUICK_REACTIONS } from '../types/meeting.types.ts';

interface ReactionBarProps {
  visible: boolean;
  onSendReaction: (emoji: string) => void;
}

const EXTRA_EMOJIS = ['🔥', '💯', '🙏', '👀', '😍', '🤣', '😎', '💪'];

const ReactionBar: React.FC<ReactionBarProps> = ({ visible, onSendReaction }) => {
  const [showMore, setShowMore] = useState(false);

  if (!visible) return null;

  return (
    <div className="absolute bottom-[5.5rem] left-1/2 -translate-x-1/2 z-[45] max-w-[95vw]">
      {/* Ek emoji paneli — kaydırma kutusunun DIŞINDA, çubuğun üstünde açılır */}
      {showMore && (
        <div className="absolute bottom-full right-0 mb-2 p-2 bg-slate-900 border border-white/15 rounded-xl shadow-xl grid grid-cols-4 gap-1 z-[46]">
          {EXTRA_EMOJIS.map((emoji) => (
            <button
              key={emoji}
              type="button"
              onClick={() => {
                onSendReaction(emoji);
                setShowMore(false);
              }}
              className="w-9 h-9 text-xl rounded-lg hover:bg-white/10 transition"
            >
              {emoji}
            </button>
          ))}
        </div>
      )}

      <div className="flex items-center gap-1 px-3 py-2 bg-slate-900/95 backdrop-blur-md border border-white/15 rounded-full shadow-2xl overflow-x-auto">
        {QUICK_REACTIONS.map((emoji) => (
          <button
            key={emoji}
            type="button"
            onClick={() => onSendReaction(emoji)}
            className="w-10 h-10 flex items-center justify-center text-2xl rounded-full hover:bg-white/10 active:scale-110 transition flex-shrink-0"
            aria-label={`${emoji} gönder`}
          >
            {emoji}
          </button>
        ))}
        <button
          type="button"
          onClick={() => setShowMore((v) => !v)}
          className={`w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0 transition ${
            showMore ? 'bg-purple-500/40 text-white' : 'bg-white/10 hover:bg-white/20 text-gray-300'
          }`}
          aria-label="Daha fazla emoji"
        >
          <SmilePlus className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default ReactionBar;
